
<script>
  import { mapState } from 'vuex';

  export default {
    render: function (_) {

      const action = this.userActions.find(ua => ua.id == this.actionId);

      if (!this.isHide && !action) {
        return this.$scopedSlots.default({
          isHavePermission: false
        });
      }

      if (!action) {
        return null;
      }

      return this.$scopedSlots.default({
        url: action.url || '#',
        name: action.name,
        vueRoute: action.url && this.$router.options.routes.find(r => r.path == action.url) || null,
        isHavePermission: true
      });
    },
    props: {
      actionId: {
        type: Number,
        required: true,
      },
      isHide: {
        type: Boolean,
        required: false,
        default: true
      }
    },
    computed: {
      ...mapState('permission', [
        'userActions'
      ])
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/CheckUserAction.vue